import Wrapper from './Wrapper';
import './Wrapper.scss';

export default Wrapper;